import { isEmptyObject } from "../../lib/utils";
 
export const formValidator = (mode, t) => (values) => {
  let formErrors = {};
 
  let name = values["Name"];
 
  if (!name || name.trim().length == 0)
    formErrors = Object.assign(formErrors, {
      Name: t("securitygroups.specify"),
    });
 
  if (isEmptyObject(formErrors)) return undefined;
 
  return formErrors;
};
 